const KeenSlider = window.KeenSlider

const { setInitialised, useArrows, addWheelControls } =
  window.BAO.Carousel.plugins

class ImageCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        mode: 'snap',
        slides: {
          perView: this.mobileCards,
          spacing: 1,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: this.tabletCards,
              spacing: 1,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: this.displayedCards,
              spacing: 1,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
        addWheelControls('horizontal'),
      ],
    )
  }

  get displayedCards () {
    return Math.min(Number(this.dataset.slides) || 3.5, 6)
  }

  get mobileCards () {
    return Math.min(Number(this.dataset.slidesMobile) || 1.3, 2)
  }

  get tabletCards () {
    return (
      Number(this.dataset.slidesTablet) ||
      (this.mobileCards + this.displayedCards) / 2
    )
  }
}

if (!customElements.get('image-carousel')) {
  customElements.define('image-carousel', ImageCarousel)
}
